/* eslint-disable no-param-reassign */
import { createSlice, DeepPartial, PayloadAction } from "@reduxjs/toolkit"

import { RootState } from "stores/store"
import { markStates } from "utils/misc"

import { CurrencyInitialState } from "./types"

const initialState: CurrencyInitialState = {
  active: { code: "USD", rate: 1, sign: "$" },
  expectedCurrencyCode: null,
}

export const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    resetCurrencyStore: (state) => {
      markStates(initialState, state)
    },
    markCurrency: (
      state,
      action: PayloadAction<DeepPartial<CurrencyInitialState>>,
    ) => {
      markStates(action.payload, state)
    },
  },
})

export const { markCurrency, resetCurrencyStore } = currencySlice.actions

export const selectActiveCurrency = (state: RootState) =>
  state.currencyReducer.active

export const selectExpectedCurrency = (state: RootState) =>
  state.currencyReducer.expectedCurrencyCode

export default currencySlice.reducer
